export default __webpack_public_path__ + "static/media/view-ticket.61e23196.svg";